export default "__VITE_ASSET__BU1xijVN__"